import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, getFormValues } from 'redux-form';
import AsyncSelect from 'react-select/lib/Async';
import DateTime from 'react-datetime';
import * as moment from 'moment';
import FilesForm from '../components/FilesForm';
import ServiceLocationDetails from '../components/ServiceLocationDetails';
import ServiceFormDetails from '../components/ServiceFormDetails';

class ServiceRequestForm extends React.Component {
  constructor() {
    super();
    this.state = {
      typeID: '',
      locationID: '',
      statusID: 0,
      showPatients: false,
      frequencyMonths: null
    };
  }

  componentDidMount() {
    const {
      initialValues: { serviceLocation, serviceType, requestStatus, completionDate, dob },
    } = this.props;

    if (serviceLocation !== null) {
      this.setState({ locationID: serviceLocation.id });
    }
    if (serviceType !== null) {
      this.setState({ typeID: serviceType.id });
      this.setState({ frequencyMonths: serviceType.frequencyMonths });
    }
    if (requestStatus !== null) {
      this.setState({ statusID: requestStatus.id });
    }
    if (completionDate !== null) {
      if (serviceType.frequencyMonths !== null)
        this.props.change('nextDueDate', moment(completionDate).add(serviceType.frequencyMonths, 'months'))
      else
        this.props.change('nextDueDate', null);
    }
    if (dob !== null) {
      const dobformatted = moment(dob).format('MM/DD/YYYY');
      this.props.change('dob', dobformatted);
    }
  }

  componentWillReceiveProps() {
    const {
      initialValues: { dob },
    } = this.props;

    if (dob !== null) {
      const dobformatted = moment(dob).format('MM/DD/YYYY');
      this.props.change('dob', dobformatted);
    }
  }

  renderField = ({
    input,
    label,
    type,
    disabled,
    readOnly,
    placeholder,
    maxLength,
    help,
    meta: { touched, error, warning },
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <input
          {...input}
          className="form-control"
          placeholder={placeholder}
          type={type}
          disabled={disabled}
          readOnly={readOnly}
          maxLength={maxLength}
        />
        <small className="help-block">{help}</small>
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  renderDOBDateField = ({
    input,
    label,
    type,
    disabled,
    readOnly,
    maxLength,
    meta: { touched, error, warning },
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <DateTime
          timeFormat={false}
          viewDate={input.value}
          {...input}
          renderInput={(props, openCalendar, closeCalendar) => {
            const value =
              props.value && moment(props.value)
                ? moment(props.value).format('MM/DD/YYYY')
                : null;
            return (
              <div className="input-group">
                <input {...props} type="hidden" />
                <input
                  className="form-control"
                  type="text"
                  value={value}
                  readOnly={readOnly}
                  disabled={disabled}
                  onFocus={openCalendar}
                />
                <span className="input-group-addon" onClick={openCalendar}>
                  <i className="fa fa-calendar" />
                </span>
              </div>
            );
          }}
          renderDay={(props, currentDate, selectedDate) => {
            return <td {...props}>{currentDate.date()}</td>;
          }}
          onChange={param => {
            if (param) {
              // console.log(param, param.format("YYYY-MM-DDThh:mm:ss"));
              input.onChange(param.format('YYYY-MM-DDTHH:mm:ss'));
            }
          }}
          disabled={disabled}
        />
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  renderDateField = ({
    input,
    label,
    type,
    disabled,
    readOnly,
    maxLength,
    meta: { touched, error, warning },
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <DateTime
          timeFormat={false}
          viewDate={input.value}
          {...input}
          renderInput={(props, openCalendar, closeCalendar) => {
            const value =
              props.value && moment(props.value)
                ? moment(props.value).format('MM/DD/YYYY')
                : moment().format('MM/DD/YYYY');
            return (
              <div className="input-group">
                <input {...props} type="hidden" />
                <input
                  className="form-control"
                  type="text"
                  value={value}
                  readOnly={readOnly}
                  disabled={disabled}
                  onFocus={openCalendar}
                />
                <span className="input-group-addon" onClick={openCalendar}>
                  <i className="fa fa-calendar" />
                </span>
              </div>
            );
          }}
          renderDay={(props, currentDate, selectedDate) => {
            return <td {...props}>{currentDate.date()}</td>;
          }}
          onChange={param => {
            if (param) {
              // console.log(param, param.format("YYYY-MM-DDThh:mm:ss"));
              input.onChange(param.format('YYYY-MM-DDTHH:mm:ss'));
            }
          }}
          disabled={disabled}
        />
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  onDateChange = (e, val) => {
    if (this.state.frequencyMonths !== null)
      this.props.change('nextDueDate', moment(val).add(this.state.frequencyMonths, 'months'))
    else
      this.props.change('nextDueDate', null);
  }

  renderAppointmentDateField = ({
    input,
    label,
    type,
    disabled,
    readOnly,
    maxLength,
    meta: { touched, error, warning },
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <DateTime
          // dateFormat="YYYY-MM-DD"
          timeFormat={true}
          viewDate={input.value}
          {...input}
          renderInput={(props, openCalendar, closeCalendar) => {
            const value =
              props.value && moment(props.value)
                ? moment(props.value).format('MM/DD/YYYY hh:mm A')
                : null;
            return (
              <div className="input-group">
                <input {...props} type="hidden" />
                <input
                  className="form-control"
                  type="text"
                  value={value}
                  readOnly={readOnly}
                  disabled={disabled}
                  onFocus={openCalendar}
                />
                <span className="input-group-addon" onClick={openCalendar}>
                  <i className="fa fa-calendar" />
                </span>
              </div>
            );
          }}
          renderDay={(props, currentDate, selectedDate) => {
            return <td {...props}>{currentDate.date()}</td>;
          }}
          onChange={param => {
            if (param) {
              // console.log(param, param.format("YYYY-MM-DDThh:mm:ss"));
              input.onChange(param.format('YYYY-MM-DDTHH:mm:ss'));
              // input.onChange(param)
            }
          }}
          disabled={disabled}
        />
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  renderSelect = ({
    input,
    readOnly,
    meta: { touched, error, warning },
    label,
    children,
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <select {...input} className="form-control" disabled={readOnly}>
          {children}
        </select>
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  renderForms = ({
    label,
    type,
    disabled,
    meta: { touched, error, warning },
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <FilesForm filesABC={this.props.initialValues.files} serviceRequestId={this.props.initialValues.id} label={label} onFileSubmit={this.onFilesChange}></FilesForm>
      </div>
    </div>
  );

  onFilesChange = (val) => {
    this.props.change('files', val);
  }

  renderTextArea = ({ input, label, meta: { touched, error, warning }, disabled }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <textarea
          {...input}
          className="form-control"
          placeholder={label}
          rows="5"
          cols="30"
          disabled={disabled}
        />
        {touched &&
          ((error && <span>{error}</span>) ||
            (warning && <span>{warning}</span>))}
      </div>
    </div>
  );

  renderClientsSelect = ({
    meta: { touched, error, warning },
    label,
    input,
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <AsyncSelect
          value={input}
          cacheOptions
          defaultOptions
          //isMulti
          loadOptions={this.searchClients}
          getOptionValue={(option) => option.code}
          getOptionLabel={(option) => option.name}
          placeholder="Type Client Name..."
          isDisabled={true}
          styles={{
            control: styles => ({
              ...styles,
              borderColor: touched && error ? 'red' : '#cccccc',
            }),
            menu: styles => ({
              ...styles,
              zIndex: 99999,
              color: '#108ee9',
            }),
          }}
          onChange={this.onClientChange}
        />
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  onClientChange = (val) => {
    this.props.change('clients', val);
  }

  searchClients = (search) => {
    return this.props.searchClients(search, 'isActive');
  }

  renderServiceTypes = ({
    meta: { touched, error, warning },
    label,
    disabled,
    input
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <AsyncSelect
          value={input.value}
          cacheOptions
          defaultOptions
          isDisabled={disabled}
          //isMulti
          loadOptions={this.searchServiceTypes}
          getOptionValue={(option) => option.id}
          getOptionLabel={(option) => option.name}
          placeholder={label}
          styles={{
            control: styles => ({
              ...styles,
              borderColor: touched && error ? 'red' : '#cccccc',
            }),
            menu: styles => ({
              ...styles,
              zIndex: 99999,
              color: '#108ee9',
            }),
          }}
          onChange={this.onServiceTypeChange}
        />
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  searchServiceTypes = () => {
    return this.props.searchServiceTypesByClient('');
  }

  onServiceTypeChange = (val) => {
    this.setState({ typeID: val.id });
    this.props.change('serviceType', val);

    this.setState({ locationID: '' });
    this.props.change('serviceLocation', null);

    var serviceType = this.props.getServiceTypeById(val.id);
    serviceType.then((data) => {
      this.setState({ frequencyMonths: data.frequencyMonths });
    });

    if (this.state.statusID === 5) {
      if (this.state.frequencyMonths !== null)
        this.props.change('nextDueDate', moment(val).add(this.state.frequencyMonths, 'months'))
      else
        this.props.change('nextDueDate', null);
    }
  }

  renderWorkLocationSelect = ({
    meta: { touched, error, warning },
    label,
    readOnly,
    input
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <AsyncSelect
          value={input.value}
          cacheOptions
          defaultOptions
          isDisabled={readOnly}
          //isMulti
          loadOptions={this.props.searchWorkLocationsByClient}
          getOptionValue={(option) => option.id}
          getOptionLabel={(option) => option.location}
          placeholder={label}
          styles={{
            control: styles => ({
              ...styles,
              borderColor: touched && error ? 'red' : '#cccccc',
            }),
            menu: styles => ({
              ...styles,
              zIndex: 99999,
              color: '#108ee9',
            }),
          }}
          onChange={this.onWorkLocationChange}
        />
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );
  
  onWorkLocationChange = (val) => {
    this.props.change('workLocation', val);
  }

  renderServiceLocationSelect = ({
    meta: { touched, error, warning },
    label,
    disabled,
    input
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <AsyncSelect
          value={input.value}
          cacheOptions
          defaultOptions
          isDisabled={disabled}
          //isMulti
          loadOptions={this.searchServiceLocations}
          getOptionValue={(option) => option.id}
          getOptionLabel={(option) => option.serviceProvider}
          placeholder={label}
          styles={{
            control: styles => ({
              ...styles,
              borderColor: touched && error ? 'red' : '#cccccc',
            }),
            menu: styles => ({
              ...styles,
              zIndex: 99999,
              color: '#108ee9',
            }),
          }}
          onChange={this.onServiceLocationChange}
        />
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  searchServiceLocations = () => {
    if (this.state.typeID !== '') {
      return this.props.searchServiceLocationsByService(this.state.typeID);
    }
  }

  onServiceLocationChange = (val) => {
    this.setState({ locationID: val.id });
    this.props.change('serviceLocation', val);
  }

  renderPhoneTypesSelect = ({
    meta: { touched, error, warning },
    label,
    input
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <AsyncSelect
          value={input.value}
          cacheOptions
          defaultOptions
          //isMulti
          loadOptions={this.props.searchPhoneTypes}
          getOptionValue={(option) => option.id}
          getOptionLabel={(option) => option.name}
          placeholder="Phone Type..."
          styles={{
            control: styles => ({
              ...styles,
              borderColor: touched && error ? 'red' : '#cccccc',
            }),
            menu: styles => ({
              ...styles,
              zIndex: 99999,
              color: '#108ee9',
            }),
          }}
          onChange={this.onPhoneTypeChange}
        />
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  onPhoneTypeChange = (val) => {
    this.props.change('phoneType', val);
  }

  renderStatesSelect = ({
    meta: { touched, error, warning },
    label,
    input
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <AsyncSelect
          value={input.value}
          cacheOptions
          defaultOptions
          //isMulti
          loadOptions={this.props.searchStates}
          getOptionValue={(option) => option.id}
          getOptionLabel={(option) => option.name}
          placeholder="State..."
          styles={{
            control: styles => ({
              ...styles,
              borderColor: touched && error ? 'red' : '#cccccc',
            }),
            menu: styles => ({
              ...styles,
              zIndex: 99999,
              color: '#108ee9',
            }),
          }}
          onChange={this.onStateChange}
        />
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  onStateChange = (val) => {
    this.props.change('state', val);
  }

  renderRequestStatusesSelect = ({
    meta: { touched, error, warning },
    label,
    disabled,
    input
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <AsyncSelect
          value={input.value}
          cacheOptions
          defaultOptions
          isDisabled={disabled}
          //isMulti
          loadOptions={this.props.searchServiceRequestStatuses}
          getOptionValue={(option) => option.id}
          getOptionLabel={(option) => option.name}
          placeholder="Status..."
          styles={{
            control: styles => ({
              ...styles,
              borderColor: touched && error ? 'red' : '#cccccc',
            }),
            menu: styles => ({
              ...styles,
              zIndex: 99999,
              color: '#108ee9',
            }),
          }}
          onChange={this.onRequestStatusChange}
        />
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  onRequestStatusChange = (val) => {
    this.props.change('requestStatus', val);
    this.setState({ statusID: val.id });
    if (val.id === 5) {
      if (this.state.frequencyMonths !== null)
        this.props.change('nextDueDate', moment(val).add(this.state.frequencyMonths, 'months'))
      else
        this.props.change('nextDueDate', null);
    }
  }

  renderOutcomeStatusesSelect = ({
    meta: { touched, error, warning },
    label,
    disabled,
    input
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <AsyncSelect
          value={input.value}
          cacheOptions
          defaultOptions
          isDisabled={disabled}
          //isMulti
          loadOptions={this.props.searchServiceOutcomeStatuses}
          getOptionValue={(option) => option.id}
          getOptionLabel={(option) => option.name}
          placeholder="Outcome..."
          styles={{
            control: styles => ({
              ...styles,
              borderColor: touched && error ? 'red' : '#cccccc',
            }),
            menu: styles => ({
              ...styles,
              zIndex: 99999,
              color: '#108ee9',
            }),
          }}
          onChange={this.onOutcomeChange}
        />
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  onOutcomeChange = (val) => {
    this.props.change('outcomeStatus', val);
    this.setState({ outcomeId: val.id });
  }

  renderServiceLocationDetails = ({ input, label, meta: { touched, error, warning }, disabled }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <ServiceLocationDetails serviceLocationId={this.state.locationID} disabled ></ServiceLocationDetails>
      </div>
    </div>
  );

  renderServiceFormDetails = ({ input, label, meta: { touched, error, warning }, disabled }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <ServiceFormDetails serviceTypeId={this.state.typeID} ></ServiceFormDetails>
      </div>
    </div>
  );

  onMouseUp = (val) => {
    setTimeout(() => this.setState({ locationID: '' }), 10000);
    setTimeout(() => this.setState({ typeID: '' }), 10000);
  }

  renderPatientsSelect = ({
    meta: { touched, error, warning },
    label,
    input,
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <AsyncSelect
          value={input.value}
          cacheOptions
          defaultOptions
          //isMulti
          loadOptions={this.searchPatients}
          getOptionValue={(option) => option.id}
          getOptionLabel={(option) => option.name}
          placeholder="Type Patient Name..."
          styles={{
            control: styles => ({
              ...styles,
              borderColor: touched && error ? 'red' : '#cccccc',
            }),
            menu: styles => ({
              ...styles,
              zIndex: 99999,
              color: '#108ee9',
            }),
          }}
          onChange={this.onPatientChange}
        />
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  onPatientChange = (val) => {
    this.props.change('patient', val);

    const d = val.name.split(' ');
    this.props.change('firstName', d[0]);
    this.props.change('lastName', d[1]);
    this.props.change('dob', d[2].substring(1, d[2].length));
    this.props.change('dob', moment(new Date(d[2].substring(1, d[2].length))).format('YYYY-MM-DD'));
    var patient = this.props.getPatient(val.id);
    patient.then((data) => {
      this.props.change('address1', data.addressLine1)
      this.props.change('address2', data.addressLine2)
      this.props.change('city', data.addressCity);
      this.props.change('zipCode', data.addressZip);
      this.props.change('email', data.email);
      const option = { id: data.stateId, name: data.addressState };
      this.props.change('state', option);
      if (data.mobilePhone !== null) {
        this.props.change('phone', data.mobilePhone);
        const option = { id: 1, name: "Mobile" };
        this.props.change('phoneType', option);
      }
      else {
        this.props.change('phone', data.homePhoneNumber);
        const option = { id: 2, name: "Home" };
        this.props.change('phoneType', option);
      }
    });
  }

  searchPatients = (search) => {
    return this.props.searchPatients(search, 'isActive');
  }

  onTypeChange = (e, val) => {
    if (val === '1') 
      this.setState({ showPatients: true });
    else
      this.setState({ showPatients: false });
  }

  render() {
    const {
      handleSubmit,
      pristine,
      submitting,
      mode,
      isExternalStakeholder,
      initialValues,
      clients
    } = this.props;

    return (
      <form className="form-horizontal" onSubmit={handleSubmit}>
        <fieldset>
          <legend>Service Request</legend>
          <Field
            name="client"
            input={clients}
            component={this.renderClientsSelect}
            label="Client(s)"
          />
          {/*<Field*/}
          {/*  className="form-control"*/}
          {/*  name="type"*/}
          {/*  component={this.renderSelect}*/}
          {/*  type="text"*/}
          {/*  label="Patient/Employee"*/}
          {/*  onChange={this.onTypeChange}*/}
          {/*>*/}
          {/*  <option value="0">Select</option>*/}
          {/*  <option value="1">Patient</option>*/}
          {/*  <option value="2">Employee</option>*/}
          {/*</Field>*/}
          {this.state.showPatients &&
            <Field
              name="patient"
              component={this.renderPatientsSelect}
              label="Patient"
            />
          }
          <Field
            className="form-control"
            name="lastName"
            component={this.renderField}
            type="text"
            placeholder="Last Name"
            label="Employee Last Name"
          />
          <Field
            className="form-control"
            name="firstName"
            component={this.renderField}
            type="text"
            placeholder="First Name"
            label="Employee First Name"
          />
          <Field
            className="form-control"
            name="employeeID"
            component={this.renderField}
            type="text"
            placeholder="Employee ID"
            label="Employee ID Number"
          />
          <Field
            className="form-control"
            name="dob"
            component={this.renderField}
            type="text"
            placeholder="MM/DD/YYYY"
            label="Date of Birth"
          />
          <Field
            name="workLocation"
            component={this.renderWorkLocationSelect}
            label="Employee Work Location"
          />
          <Field
            className="form-control"
            name="address1"
            component={this.renderField}
            type="text"
            placeholder="Address Line 1"
            label="Address Line 1"
          />
          <Field
            className="form-control"
            name="address2"
            component={this.renderField}
            type="text"
            placeholder="Address Line 2"
            label="Address Line 2"
          />
          <Field
            className="form-control"
            name="city"
            component={this.renderField}
            placeholder="City"
            type="text"
            label="City"
          />
          <Field
            className="form-control"
            name="state"
            component={this.renderStatesSelect}
            label="State"
          />
          <Field
            className="form-control"
            name="zipCode"
            component={this.renderField}
            type="text"
            label="Zip"
            placeholder="Zip"
            maxLength={5}
          />
          <Field
            className="form-control"
            name="email"
            component={this.renderField}
            placeholder="Email"
            type="text"
            label="Email"
          />
          <Field
            className="form-control"
            name="phone"
            component={this.renderField}
            type="text"
            placeholder="(XXX) XXX-XXXX"
            label="Phone"
          />
          <Field
            className="form-control"
            name="phoneType"
            component={this.renderPhoneTypesSelect}
            label="Phone Type"
          />
          <Field
            className="form-control"
            name="availability"
            component={this.renderTextArea}
            type="textarea"
            placeholder="Availability"
            label="Availability"
          />
        </fieldset>
        <fieldset>
          <legend></legend>
          <Field
            name="serviceType"
            component={this.renderServiceTypes}
            label="Service Requested"
            disabled={isExternalStakeholder && (initialValues.requestStatus ? initialValues.requestStatus.id > 1 : false)}
          />
          {(this.state.typeID) && (
            <Field
              key={this.state.typeID}
              name="forms"
              component={this.renderServiceFormDetails}
              label="Required Forms"
            />
          )}
          <Field
            className="form-control"
            name="requestedCompletion"
            component={this.renderDateField}
            type="text"
            label="Requested Completion"
            disabled={isExternalStakeholder && (initialValues.requestStatus ? initialValues.requestStatus.id > 1 : false)}
          />
            <Field
              name="requestStatus"
              component={this.renderRequestStatusesSelect}
              label="Status"
              disabled={isExternalStakeholder}
            />
          {(this.state.statusID === 5) && (
            <Field
              name="completionDate"
              component={this.renderDateField}
              type="text"
              label="Completion Date"
              onChange={this.onDateChange}
            />
          )}
          {(this.state.statusID === 5) && (
            <Field
              name="nextDueDate"
              component={this.renderDateField}
              type="text"
              label="Next Due Date"
            />
          )}
          {(this.state.statusID === 5) && (
            <Field
              name="outcomeStatus"
              component={this.renderOutcomeStatusesSelect}
              label="Outcome"
              disabled={isExternalStakeholder}
            />
          )}
          {(this.state.statusID === 6) && (
            <Field
              className="form-control"
              name="cancelReason"
              component={this.renderField}
              type="text"
              label="Cancel Reason"
            />
          )}
          {(mode === 'Edit') && (
            <Field
              className="form-control"
              name="appointments.appointmentAt"
              component={this.renderAppointmentDateField}
              type="text"
              label="Appointment Date/Time"
              disabled={(isExternalStakeholder && (initialValues.requestStatus ? initialValues.requestStatus.id > 1 : false))
                || (this.state.statusID === 5 || this.state.statusID === 6) ? true : false}
            />
          )}
        </fieldset>
        <fieldset>
          <Field
            key={this.state.typeID}
            name="serviceLocation"
            component={this.renderServiceLocationSelect}
            label="Suggested Service Location"
            disabled={(isExternalStakeholder && (initialValues.requestStatus ? initialValues.requestStatus.id > 1 : false))
              || (this.state.statusID === 5 || this.state.statusID === 6) ? true : false}
          />
          {(this.state.locationID) && (
            <Field
              key={this.state.locationID}
              name="locationDetails"
              component={this.renderServiceLocationDetails}
              //disabled={mode === 'Edit' ? true : false}
            />
          )}
        </fieldset>
        <fieldset>
          {(mode === 'Edit') && (
            <div className="form-group">
              <label className="col-md-2 control-label"></label>
              <div className="col-md-10">
                <div className="checkbox">
                  <label>
                    <Field
                      name="appointments.emailCopyServiceLocation"
                      component="input"
                      type="checkbox"
                      disabled={(this.state.statusID === 5 || this.state.statusID === 6) ? true : false}
                    /> Send Email Copy to Service Location
                  </label>
                </div>
              </div>
            </div>
          )}
          {(this.state.statusID === 5 || this.state.statusID === 6) && (
            <Field
              className="form-control"
              name="appointments.emailReportCopyTo"
              component={this.renderField}
              type="text"
              label="Email Report Copy To"
              disabled={(this.state.statusID === 6) ? true : false }
            />
          )}
        </fieldset>
        <div className="form-actions">
          <div className="row">
            <div className="col-md-12">
              <button
                onClick={this.props.onCancel}
                className="btn btn-default"
                type="button"
              >
                Cancel
              </button>{' '}
              <button
                className="btn btn-primary"
                type="submit"
                disabled={pristine || submitting}
              >
                <i className="fa fa-save" /> Save
              </button>
              {' '}
              {(mode === 'Add') && (
              <button
                className="btn btn-primary"
                onClick={(e) => this.props.onSaveOther(e)}
                onMouseUp={this.onMouseUp}
                id="saveother"
                type="submit"
                disabled={pristine || submitting}
              >
                <i className="fa fa-save" /> Save & Add Other Service
            </button>
              )}
            </div>
          </div>
        </div>
      </form>
    );
  }
}
const validate = values => {
  const errors = {};
  if (!values.lastName) {
    errors.lastName = 'Required';
  }
  if (!values.firstName) {
    errors.firstName = 'Required';
  }
  if (!values.dob) {
    errors.dob = 'Required';
  } else if (!/^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(18|19|20)\d{2}$/i.test(values.dob)) {
    errors.dob = 'Invalid DOB';
  }
  if (!values.workLocation) {
    errors.workLocation = 'Required';
  }
  //if (!values.address1) {
  //  errors.address1 = 'Required';
  //}
  //if (!values.city) {
  //  errors.city = 'Required';
  //}
  //if (!values.state) {
  //  errors.state = 'Required';
  //}
  //if (!values.zipCode) {
  //  errors.zipCode = 'Required';
  //}
  if (!values.email) {
    errors.email = 'Required';
  }
  if (!values.phone) {
    errors.phone = 'Required';
  }
  if (!values.phoneType) {
    errors.phoneType = 'Required';
  }
  if (!values.availability) {
    errors.availability = 'Required';
  }
  if (!values.serviceType) {
    errors.serviceType = 'Required';
  }
  if (!values.requestedCompletion) {
    errors.requestedCompletion = 'Required';
  }
  if (!values.serviceLocation) {
    errors.serviceLocation = 'Required';
  }

  return errors;
};

ServiceRequestForm = connect(state => ({
  formValues: getFormValues('serviceRequest')(state),
  initialValues: state.servicerequestmanager.serviceRequest,
  enableReinitialize: true,
  validate: validate,
}))(reduxForm({ form: 'serviceRequest' })(ServiceRequestForm));
export default ServiceRequestForm;



// WEBPACK FOOTER //
// ./src/routes/service-request-manager/components/ServiceRequestForm.js